export default "__VITE_ASSET__DyHnbsZb__"